import { LoggerLevelEnum } from './logger.enum'

export class LoggerStyle {
  // Default LogLevel style
  static getLevelStyle(level: LoggerLevelEnum): string {
    const levelStyle = [
      'padding: 2px 4px',
      'font-weight: 900',
      'font-size: 1.2em',
      'border-radius: 25% 10%'
    ];

    switch(level) {
      case LoggerLevelEnum.TRACE:
      case LoggerLevelEnum.DEBUG:
        levelStyle.push('color: #FFF')
        levelStyle.push('background-color: #663300')
        break;
      case LoggerLevelEnum.INFO:
      case LoggerLevelEnum.LOG:
        levelStyle.push('color: #000')
        levelStyle.push('background-color: #33ccff')
        break;
      case LoggerLevelEnum.WARN:
        levelStyle.push('color: #000')
        levelStyle.push('background-color: #cc9900')
        break;
      case LoggerLevelEnum.ERROR:
      case LoggerLevelEnum.FATAL:
        levelStyle.push('color: #000')
        levelStyle.push('background-color: #ff0000')
        break;
      default:
        levelStyle.push('color: #FFF')
        levelStyle.push('background-color: #0099ff')
        break;
    }

    return levelStyle.join(';')
  }

  // Default Title style
  static titleStyle = [
    'color: #000',
    'background-color: #0D0',
    'padding: 2px 4px',
    'font-weight: bold',
    'border-radius: 6px'
  ].join(';')

  // Default Content style
  static contentStyle = [
    'font-weight: bold'
  ].join(';')

  // Default Location style
  static locationStyle = [
    'font-style: italic'
  ].join(';')
}
